import { generateUUID } from 'syf-js-utilities/helpers';
import store from './store';
const getAuthHeaders = () => {
    const accessToken = store.get('accessToken', 'session');
    const correlationId = store.get('correlationId', 'session') || '';
    return {
        Authorization: `Bearer ${accessToken}`,
        'X-SYF-Request-CorrelationId': correlationId,
        'X-SYF-Request-TrackingId': generateUUID()
    };
};
export default getAuthHeaders;
